export const ROWS_PER_PAGE = 10;
export const DATE_FORMAT = 'yyyy-MM-dd';
export const DATE_TIME_FORMAT = 'yyyy-MM-dd HH:mm';
export const IMAGE_LIMIT = 10;
export const FULL_DATE_TIME_FORMAT = 'yyyy-MM-ddTHH:mm';
export const DATE_PICKER_FORMAT = 'M-dd-yy';
export const LIST_VIEW_DATE_FORMAT = 'MMM-dd-yyyy';
